export default {
  en: {
    'components.registration-access.change-roll': 'Change user role',
    'components.registration-access.no-adjust': 'Cannot change access',
    'components.registration-access.msp-user':
      'This MSP user will automatically have access to all managed registrations.',
    'components.registration-access.restricted-role':
      'Registration access cannot be changed for the current user role. If you need to change access at this level you will need to change their role first.',
  },
};
